<mt-filter
    [filterConfig]="filterConfig"
    [progressBar]="filterConfig.isLoading"
    (filterChange)="fillTableHourmeterSignalVital($event)"
></mt-filter>
<div
    class="report-container mt-4"
    *ngIf="tableConfig || message || systemError"
>
    <div class="header-container">
        <div class="header">
            <div class="float-left">
                <div class="title">
                    {{ "report-signal-vital-hourmeter" | lang | uppercase }}
                </div>
            </div>
            <div class="float-right" *ngIf="hasData">
                <app-button-icon
                    [image]="'download'"
                    [iconType]="'icon'"
                    [disabled]="disabledExcelBtn"
                    [spinner]="btnSpinner"
                    (clickHandler)="downloadExcel()"
                ></app-button-icon>
            </div>
        </div>
    </div>
    <div [ngClass]="{ 'body-container': tableConfig }">
        <div class="d-flex flex-row message" *ngIf="message">
            <img
                class="message-img"
                appImageSelector
                [imageType]="'icon'"
                [imageKey]="'error-red'"
                alt="imagen-icon"
            />
            <span class="message-text">{{ message }}</span>
        </div>

        <app-system-error-message
            *ngIf="!!systemError"
            [message]="systemError"
        ></app-system-error-message>
        <app-main-table
            class="table-hourmeter"
            [tableConfig]="tableConfig"
            *ngIf="hasData && tableConfig"
        ></app-main-table>
    </div>
</div>
